module.exports = __webpack_public_path__ + "static/media/instagram_logo.8037d8b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instagram_logo.svg
// module id = 476
// module chunks = 7